// extracted by mini-css-extract-plugin
module.exports = {"layoutsContainer":"styles_layoutsContainer__NJuBr"};